module.exports = __webpack_public_path__ + "static/img/permata.418629e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/permata.png
// module id = MPQ1
// module chunks = 1